/**
 * src/admin-ui/src/navigation.ts
 *
 * Shared navigation configuration for the footer and dashboard.
 */

import { User } from './types/auth';
import { isAdmin } from './utils/roles';

export interface NavigationItem {
  label: string;
  path: string;
  adminOnly?: boolean;
}

export const NAVIGATION_ITEMS: readonly NavigationItem[] = [
  { label: 'Консоль', path: '/dashboard' },
  { label: 'API Ключи', path: '/api-keys' },
  { label: 'Пополнение', path: '/billing' },
  { label: 'Пользователи', path: '/admin/users', adminOnly: true },
  { label: 'Цены моделей', path: '/admin/pricing', adminOnly: true },
  { label: 'Аналитика моделей', path: '/admin/model-usage', adminOnly: true },
];

/**
 * Return navigation items available to a user.
 *
 * :param user: Current authenticated user.
 * :returns: Navigation items allowed by the user's role.
 */
export function getNavigationItems(user: User | null): NavigationItem[] {
  return NAVIGATION_ITEMS.filter((item) => !item.adminOnly || isAdmin(user));
}
